(function($) {
	$( '.description-slider' ).slick(
		{
			dots: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			infinity: true,
			autoplay: true,
			autoplaySpeed: 6000,
			fade: true,
			adaptiveHeight: true,
		}
	);

	$( '.big-slider' ).slick(
		{
			dots: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			fade: true,
			adaptiveHeight: false,
			customPaging: function(slider, i) {
				return '<button type="button" role="tab" id="slick-slide-control0' + i + '" aria-controls="slick-slide0' + i + '" aria-label="' + (i+1) + ' of ' + slider.$slides.length + '" tabindex="0">' + $(slider.$slides[i]).data('caption') + '</button>'
			},
		}
	);
}(jQuery));
